import {
  FundraisingDocumentInfosFragment,
  FundraisingDocumentType,
  FundraisingStatus,
} from '@blockpulse3/graphql/hooks';

type FundraisingDocumentRecord = Record<
  FundraisingDocumentType | string,
  FundraisingDocumentInfosFragment
>;

/**
 * getFundraisingProgressionStep.
 * Return current fundraising progression step.
 *
 * @param {FundraisingStatus} status
 * @returns {number}
 */
export function getFundraisingProgressionStep(status: FundraisingStatus): number {
  switch (status) {
    case FundraisingStatus.DRAFT:
    case FundraisingStatus.VALIDATED:
      return 1;
    case FundraisingStatus.STARTED:
      return 2;
    case FundraisingStatus.CLOSED:
    case FundraisingStatus.REVIEWED:
      return 3;
    case FundraisingStatus.FINALIZED:
      return 4;
    default:
      return 1;
  }
}

/**
 * getFundraisingDocuments.
 *
 * @param {Array} documents
 * @returns {FundraisingDocumentRecord}
 */
export function getFundraisingDocuments(
  documents: FundraisingDocumentInfosFragment[],
): FundraisingDocumentRecord {
  const FundraisingDocumentTypesToSign: string[] = [
    FundraisingDocumentType.PV_EXERCICE,
    FundraisingDocumentType.PV_CONSTATATION,
  ];
  const docs: Record<FundraisingDocumentType | string, FundraisingDocumentInfosFragment> = {};
  documents.forEach((doc) => {
    if (FundraisingDocumentTypesToSign.includes(doc?.type)) {
      docs[doc?.type] = doc;
    }
  });
  return docs;
}
